// extracted by mini-css-extract-plugin
module.exports = {"container":"BaseContent_container___KKJB"};